'use es6';

export default {
  sidekick: {
    extensionUrl: 'https://chrome.google.com/webstore/detail/oiiaigjnkhngdbnoookogelabohpglmd'
  }
};